import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Divider from 'src/components/common/designSystem/Divider';
import Button from 'src/components/common/designSystem/Button';
import LoginWithGoogleButton from './LoginWithGoogleButton';
import LoginWithAppleButton from './LoginWithAppleButton';

interface LoginPanelProps {
  className?: string;
  onLogin?: () => void;
  title?: string;
  onEmailClick?: () => void;
  useSearchParams?: boolean;
  allowFamilyCode?: boolean;
}

const LoginPanel = ({
  className,
  onLogin,
  title,
  onEmailClick,
  allowFamilyCode,
}: LoginPanelProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleEmailClick = () => {
    if (onEmailClick) {
      onEmailClick();
    } else {
      navigate(`/login/email${searchParams.toString()}`);
    }
  };

  const handleWithFamilyCodeClick = () => {
    navigate(`/family-code${searchParams.toString()}`);
  };

  return (
    <div
      className={`flex flex-col justify-center items-center p-6 gap-6 ${className}`}
    >
      {title && (
        <div className={'font-extrabold text-xl text-balance text-center'}>
          {title}
        </div>
      )}
      <div className={'flex flex-col gap-2 w-full'}>
        {allowFamilyCode ? (
          <Button
            data-testid="btn-login-family-code"
            onClick={handleWithFamilyCodeClick}
            className="w-full"
          >
            {t('login.withFamilyCode')}
          </Button>
        ) : null}
        <Button
          data-testid="btn-login-email"
          onClick={handleEmailClick}
          className="w-full"
        >
          {t('login.withEmail')}
        </Button>
        <Divider>{t('global.or')}</Divider>
        <LoginWithGoogleButton onLogin={onLogin} />
        <LoginWithAppleButton onLogin={onLogin} />
      </div>
    </div>
  );
};

export default LoginPanel;
